<template>
  <div>
    <flota-form
      :is-toggle-sidebar.sync="isToggleSidebar"
      :form-type="formType"
      :data-edit="dataEdit"
      @refetch-data="refetchData"
      @error-data="showError"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrando</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="pageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>registros</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="query"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <b-button
                variant="primary"
                @click="openForm('new')"
              >
                <span class="text-nowrap">Agregar</span>
              </b-button>
              <b-button
                v-b-tooltip.hover.top="`Requiere usuario tipo administrador`"
                variant="info"
                class="ml-50"
                @click="envApp === 'development' ? syncMTC() : null"
              >
                <span class="text-nowrap">Sync MTC</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="items"
        responsive
        :fields="fields"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No se encontraron registros"
        :busy="isBusy"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner
              variant="primary"
              class="align-middle"
            />
            <strong class="ml-1">Cargando...</strong>
          </div>
        </template>
        <!-- Column: Issued Date -->
        <template #cell(tipoFlota)="data">
          <b-badge
            :variant="`light-${getColorAvatar(data.item.tipoFlota.descripcion)}`"
          >
            <span>{{ data.item.tipoFlota.descripcion }}</span>
          </b-badge>
        </template>
        <!-- Column: Status -->

        <!-- Column: Client -->
        <template #cell(placa)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                :id="`flota-registro-${data.item.idFlota}`"
                size="32"
                :variant="`light-${getColorAvatar(data.item.tipoFlota.descripcion)}`"
              >
                <feather-icon
                  icon="TruckIcon"
                />
              </b-avatar>
            </template>
            <span class="font-weight-bold d-block text-nowrap">
              PLACA: {{ data.value }}
            </span>
            <small class="text-muted d-block">Capacidad {{ data.item.capacidad }} {{ data.item.unidadMedida }}</small>
            <small class="text-muted d-block">{{ data.item.marca }} {{ data.item.modelo }}</small>
          </b-media>
        </template>

        <template #cell(mtcEstado)="data">
          <div
            v-if="data.item.mtcEstado === 'Habilitado'"
          >
            <b-badge
              pill
              variant="light-success"
              class="text-capitalize"
            >
              {{ data.item.mtcEstado }} - {{ data.item.mtcVigencia }}
            </b-badge>
            <small class="text-muted d-block">Partida: {{ data.item.mtcPartida }}</small>
            <small class="text-muted d-block">Constancia: {{ data.item.mtcConstancia }}</small>
          </div>
          <b-badge
            v-else
            pill
            variant="light-dark"
            class="text-capitalize"
          >
            No Registra
          </b-badge>
        </template>

        <template #cell(conductor)="data">
          <b-media
            v-if="data.item.conductor"
            vertical-align="center"
          >
            <template #aside>
              <b-avatar
                size="32"
                :src="`data:image/jpeg;base64,${data.item.conductor.foto}`"
                :text="avatarText(`${data.item.conductor.nombre} ${data.item.conductor.apellidoPaterno}`)"
                :variant="`light-primary`"
              />
            </template>
            <span class="font-weight-bold d-block text-nowrap font-small-3">
              {{ data.item.conductor.nombre }}
            </span>
            <small class="text-muted">{{ data.item.conductor.apellidoPaterno }} {{ data.item.conductor.apellidoMaterno }}</small>
          </b-media>
          <small
            v-else
            class="text-muted"
          >
            NO REGISTRA
          </small>
        </template>

        <template #cell(estado)="data">
          <b-badge
            v-if="data"
            pill
            variant="light-success"
            class="text-capitalize"
          >
            Activo
          </b-badge>

          <b-badge
            v-else
            pill
            variant="light-danger"
            class="text-capitalize"
          >
            Inactivo
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(acciones)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="getEdit(data)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>

            <b-dropdown-item @click="getDelete(data)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Eliminar</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ from }} a {{ to }} de {{ of }} registros</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="page"
              :total-rows="totalItems"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BBadge, BDropdown, BDropdownItem, BPagination, BAvatar, BMedia, BSpinner, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { avatarText } from '@core/utils/filter'
import { showToast, showError } from '@/helpers'
import FlotaForm from './FlotaForm.vue'

export default {
  components: {
    FlotaForm,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BAvatar,
    BMedia,

    vSelect,
    BSpinner,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data: () => ({
    envApp: process.env.NODE_ENV,
    isBusy: false,
    isToggleSidebar: false,
    dataEdit: {},
    formType: '',
    page: 1,
    perPage: 10,
    totalRows: 0,
    totalItems: 0,
    totalPage: 0,
    from: 0,
    to: 0,
    of: 0,
    pageOptions: [10, 20, 50],
    sortBy: null,
    sortDesc: false,
    sortDirection: 'asc',
    query: '',
    items: [],
    fields: [
      { key: 'idFlota', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
      { key: 'placa', label: 'Vehículo', sortable: true },
      { key: 'mtcEstado', label: 'MTC', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
      { key: 'tipoFlota', label: 'Tipo de Flota', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
      { key: 'conductor', sortable: true },
      { key: 'acciones', tdClass: ['w100', 'text-center'], thClass: 'text-center' },
    ],
    tiposProducto: [
      {
        text: 'Todos',
        value: '',
      },
      {
        text: 'CILINDRO',
        value: 'CILINDRO',
      },
      {
        text: 'GRANEL',
        value: 'GRANEL',
      },
    ],
    tipoProductoSel: '',
  }),
  watch: {
    perPage: {
      handler() {
        this.listarRegistros()
      },
    },
    page: {
      handler() {
        this.listarRegistros()
      },
    },
    query: {
      handler() {
        this.listarRegistros()
      },
    },
  },
  async mounted() {
    await this.listarRegistros()
  },
  methods: {
    avatarText,
    async listarRegistros() {
      this.isBusy = true
      await store
        .dispatch('inventario/FLOTA_FIND_ALL', {
          idTipoFlota: -1,
          limit: this.perPage,
          query: this.query,
          page: this.page,
          sortBy: 'idFlota%7CDESC',
          tipo: 'grilla',
        })
        .then(response => {
          this.items = response.items
          this.totalRows = response.totalRows
          this.totalItems = response.totalItems
          this.totalPage = response.totalPage
          this.from = this.perPage * (this.page - 1) + (this.totalRows ? 1 : 0)
          this.to = this.perPage * (this.page - 1) + this.totalRows
          this.of = this.totalItems
        })
        .catch(error => {
          this.$bvToast.toast(error, {
            title: 'Ha ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
      this.isBusy = false
    },
    syncMTC() {
      this.$swal({
        title: 'Está seguro?',
        text: 'Va sincronizar con el portal del MTC!',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          await store
            .dispatch('helpers/GET_CONSTANCE', {
              ruc: '20542206188',
            })
            .then(response => {
              this.listarRegistros()
              this.$bvToast.toast('Ha sincroinizado correctamente los datos.', {
                title: 'Operación Exitosa',
                variant: 'success',
                solid: true,
              })
              return response
            })
            .catch(error => {
              this.$bvToast.toast(error, {
                title: 'Ha ocurrido un error',
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    },
    openForm(type) {
      this.formType = type
      this.isToggleSidebar = true
    },
    getEdit(data) {
      this.formType = 'edit'
      this.isToggleSidebar = true
      this.dataEdit = data.item
    },
    getDelete(data) {
      this.$swal({
        title: 'Está seguro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('inventario/FLOTA_DELETE', {
              id: data.item.idFlota,
            })
            .then(response => {
              this.listarRegistros()
              this.$bvToast.toast('Ha Eliminado correctamente el registro.', {
                title: 'Operación Exitosa',
                variant: 'success',
                solid: true,
              })
              return response
            })
            .catch(error => {
              this.$bvToast.toast(error, {
                title: 'Ha ocurrido un error',
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    },
    getColorAvatar(type) {
      if (type === 'GRANELERO') return 'primary'
      if (type === 'CISTERNA') return 'success'
      if (type === 'CARGUERO') return 'info'
      return 'primary'
    },
    refetchData(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.showToast('Operación Extitosa', message, 'success')
      this.listarRegistros()
    },
    showToast,
    showError,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style>
.w100{
  width: 100px !important;
}
.badge{
  font-size: 75% !important;
}
</style>
